// extracted by mini-css-extract-plugin
export default {"copyright":"Footer_copyright__lvAsb","bold":"Footer_bold__G1rAD"};